module.exports = class CUCookie {

  constructor() {
    this.initialize();
  }

  async initialize() {
    document.addEventListener("cookieyes_banner_load", function (eventData) {
      let ckyButtons = document.querySelectorAll('.cky-btn');

      if (!ckyButtons.length) {
        return;
      }

      ckyButtons.forEach(function (button) {
        const arrowWrapper = document.createElement('span');
        arrowWrapper.classList.add('arrow-wrapper');
        button.append(arrowWrapper);
      });
    });
  }

};